import React, { memo } from 'react';
import { Checkbox, List } from '@mui/material';

import { makeStyles } from '~/UIKit/Style';
import { BORDER_COLOR } from '~/Constants/Colors.constants';
import {
  IModalSelectPopoverItem,
  ModalSelectPopoverItem,
} from '~/UIKit/Form/ModalSelect/listTypes/index';

const useStyles = makeStyles(() => ({
  container: {
    borderTop: `1px solid ${BORDER_COLOR}`,
    margin: '0 -15px',
    padding: 0,
  },
  Checkbox: {
    marginLeft: 'auto',
  },
}));

interface IModalSelectCheckboxList {
  list: Omit<IModalSelectPopoverItem, 'onClick' | 'children'>[];
  selectedMap: Record<string, number>;
  onSelect: (item: any) => void;
  idName?: string;
}

export const ModalSelectCheckboxList = memo(
  ({ list, selectedMap, onSelect, idName = 'id' }: IModalSelectCheckboxList) => {
    const { classes } = useStyles();

    return (
      <List className={classes.container} data-testid="List">
        {list.map((item) => (
          <ModalSelectPopoverItem
            key={String(item[idName as keyof typeof item])}
            name={item.name}
            onClick={() => onSelect(item)}
            icon={item.icon}
            imageUrl={item.imageUrl}
            testId="ListItemSelect"
          >
            <Checkbox
              checked={String(item[idName as keyof typeof item]) in selectedMap}
              color="primary"
              className={classes.Checkbox}
            />
          </ModalSelectPopoverItem>
        ))}
      </List>
    );
  },
);
